import { useEffect, useState } from 'react';

import { BeakerOutline, Box } from '@bonusly/design-system';
import { ProductTier, useCurrentCompany, useCurrentUser } from '@bonusly/who-am-i';

export function BonuslyWebTools() {
	const company = useCurrentCompany();
	const user = useCurrentUser();
	const [visible, setVisible] = useState(false);

	const available = user?.super_admin;

	useEffect(() => {
		if (!available) return;
		const handleKeyDown = (ev: globalThis.KeyboardEvent) => {
			if (ev.ctrlKey) setVisible(true);
		};
		const handleKeyUp = (ev: globalThis.KeyboardEvent) => {
			if (!ev.ctrlKey) setVisible(false);
		};
		document.addEventListener('keydown', handleKeyDown);
		document.addEventListener('keyup', handleKeyUp);
		return () => {
			document.removeEventListener('keydown', handleKeyDown);
			document.removeEventListener('keyup', handleKeyUp);
		};
	}, [available]);

	// Color coding and names for different tiers
	const getTierInfo = (tier: ProductTier) => {
		switch (tier) {
			case ProductTier.TierOne:
				return { color: '#ff6b6b', name: 'Appreciate (tier_one)' };
			case ProductTier.TierTwo:
				return { color: '#4ecdc4', name: 'Connect (tier_two)' };
			case ProductTier.TierThree:
				return { color: '#45b7d1', name: 'Organization (tier_three)' };
			case ProductTier.TierAlpha:
				return { color: '#96ceb4', name: 'Team (tier_alpha)' };
			default:
				return { color: '#95a5a6', name: `Unknown (${tier})` };
		}
	};

	const tierInfo = getTierInfo(company.product_tier);

	if (!available || !visible) return null;

	return (
		<Box
			alignItems="center"
			bgColor={tierInfo.color}
			borderRadius="100% 0 0 100%"
			boxShadow="md"
			color="white"
			display="flex"
			h={10}
			justifyContent="center"
			right={-3}
			position="fixed"
			transition="all 0.2s"
			top={3}
			w={10}
			zIndex={Number.MAX_SAFE_INTEGER}
			title={tierInfo.name}
		>
			<BeakerOutline size="sm" />
		</Box>
	);
}
